var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroup = void 0;
var RadioGroup_1 = __importDefault(require("./RadioGroup"));
exports.RadioGroup = RadioGroup_1.default;
exports.default = RadioGroup_1.default;
//# sourceMappingURL=index.js.map